
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#213CFC","d":"M0 0h150v100H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h150v33.333H0z"}}),_c('path',{attrs:{"fill":"#BE1E2D","d":"M0 67h150v33.333H0z"}})])])
          )
        }
      }
    